<template lang="pug">
.auth-layout
   .nav.hidden-lg-up
     router-link.i-keylogs(:to="{path: '/'}")
   .main.row
     .auth-content.col-lg-6.col-12
       router-view
     .auth-wallpaper.col-6.hidden-md-down
       .oblique
       .row
          .col-12
             router-link.i-keylogs(:to="{path: '/'}")
          .col-12
              h1.claim Better Search Console Insights
</template>

<script>
  export default {
    name: 'AuthLayout'
  }
</script>

<style lang="scss">
  @import '../../sass/variables';
  @import '../../../node_modules/bootstrap/scss/mixins/breakpoints';
  @import '../../../node_modules/bootstrap/scss/variables';
  .auth-layout {
    height: 100%;
    margin: 0;
    .claim {
      color: #efefef;
      z-index: 99;
      font-size: $font-size-h3;
   }
    .nav {
      display: flex;
      align-items: center;
      justify-content: center;
      height: $top-mobile-nav-height;
      background-color: $top-nav-bg;
      .i-vuestic {
        height: $auth-mobile-nav-ivuestic-h;
        width: 100%;
      }
    }
    .main {
      margin: 0;
      height: 100%;
      .auth-content {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
      }
      .auth-wallpaper {
        background-color: $top-nav-bg;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .i-vuestic {
          z-index: 2;
          height: $auth-wallpaper-ivuestic-h;
          width: 100%;
        }
        .oblique {
          position: absolute;
          background-color: $auth-wallpaper-oblique-line;
          left: calc(50% - 27%/2);
          transform: rotate(15deg);
          width: 27%;
          opacity: .5;
          height: 115%;
          top: -3rem;
        }
      }
    }

    @include media-breakpoint-down(md) {
      .main {
        height: $auth-mobile-main-h;
        .auth-content {
          align-items: flex-start;
          padding-top: $auth-content-padding-t;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/AuthLayout.vue